<script setup>
import { CheckIcon, InformationCircleIcon } from '@heroicons/vue/24/outline'

defineProps({
  number: {
    type: Number,
    required: true
  },
  title: {
    type: String,
    required: true
  },
  duration: {
    type: String,
    required: true
  },
  description: {
    type: String,
    required: true
  },
  note: {
    type: Object,
    default: null
    // { type: 'success' | 'info', text: string }
  },
  isLast: {
    type: Boolean,
    default: false
  }
})
</script>

<template>
  <div class="flex gap-6">
    <div class="flex flex-col items-center">
      <div class="w-16 h-16 bg-accent-500 rounded-2xl flex items-center justify-center text-white font-bold text-xl">
        {{ number }}
      </div>
    </div>
    <div class="flex-1" :class="{ 'pb-8': !isLast }">
      <div class="bg-bg-primary rounded-2xl p-6 border border-slate-200">
        <div class="flex flex-wrap items-center gap-4 mb-3">
          <h3 class="text-xl font-bold text-text-primary">{{ title }}</h3>
          <span class="px-3 py-1 bg-accent-100 text-accent-700 text-sm font-medium rounded-full">
            {{ duration }}
          </span>
        </div>
        <p class="text-text-secondary">{{ description }}</p>

        <!-- Note (optional) -->
        <div
          v-if="note"
          class="flex items-center gap-2 text-sm px-3 py-2 rounded-lg mt-3"
          :class="{
            'text-green-700 bg-green-50': note.type === 'success',
            'text-accent-700 bg-accent-50': note.type === 'info'
          }"
        >
          <CheckIcon v-if="note.type === 'success'" class="w-4 h-4" />
          <InformationCircleIcon v-else class="w-4 h-4" />
          <span>{{ note.text }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
